import { observeElement } from '@uvocore-front/utils';
import '../../../components/PriceTable';
import '../../../components/Section/js/FeaturesSection';
import '../../../components/Calculator';
import '../../../components/Section/js/CtaSection';
import '../../../theme/DefaultTheme';

import Accordion from '../../../components/UI/Accordion';


document.addEventListener('DOMContentLoaded', () => {
  // run accordion
  observeElement({
    element: '.Accordion',
    marginValue: 400,
    callback: () => {
      const acc = new Accordion({ // eslint-disable-line
        itemsSelector: '.Accordion__item',
      });
    },
  });
});
